var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "footer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7422",
    "data-name": "Rectangle 7422",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11072",
    "data-name": "Path 11072",
    d: "M8.5,16a1.5,1.5,0,1,0,0,3h7a1.5,1.5,0,0,0,0-3ZM19.99,4.092A2.25,2.25,0,0,0,17.745,2H6.245L6.091,2A2.25,2.25,0,0,0,4,4.246v15.5L4,19.9a2.25,2.25,0,0,0,2.245,2.1h11.5l.154-.005A2.25,2.25,0,0,0,20,19.744V4.246ZM6.245,3.5h11.5l.1.007a.75.75,0,0,1,.648.743v15.5l-.007.1a.75.75,0,0,1-.743.648H6.245l-.1-.007a.75.75,0,0,1-.648-.743V4.246l.007-.1A.75.75,0,0,1,6.245,3.5Z",
    transform: "translate(0.005 0.004)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.229a614de2ba32d7a1f5af3763a12c54.svg";
export { ForwardRef as ReactComponent };